<nav class="py-4">
  <ul class="space-y-1">
    @for (item of navItems; track item.sectionId) {
      <li>
        <button
          (click)="scrollToSection(item.sectionId)"
          class="w-full flex items-center gap-3 px-4 py-3 text-left text-slate-300 hover:text-white hover:bg-white/5 transition-colors rounded-lg">
          <span class="text-sm font-medium">{{ item.name }}</span>
        </button>
      </li>
    }
  </ul>

  <div class="mt-4 pt-4 border-t border-white/10">
    <button
      (click)="openProductSite()"
      class="w-full flex items-center gap-3 px-4 py-3 text-left text-primary-400 hover:text-primary-300 hover:bg-white/5 transition-colors rounded-lg">
      <span class="text-sm font-medium">Product Site</span>
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
      </svg>
    </button>
  </div>
</nav>
